import*as e from"react";function r({externalRef:r,internalRef:t}){return e.useCallback((e=>{"function"==typeof r?r(e):r&&(r.current=e),t.current=e}),[r,t])}export{r as useComposeRefsCallback};
